import { useMutation } from '@tanstack/react-query';
import { createUrl } from 'src/core/api/utils/createUrl';
import { fetch as fetchRedirect } from 'src/utils/refetch';

const useBonusCodeMutation = () => {
  const { mutate, isLoading } = useMutation({
    mutationFn: async (data: any) => {
      const response = await fetchRedirect(createUrl('/bonuscode/use'), {
        method: 'POST',
        body: JSON.stringify(data),
      });
      if (!response.response.ok) {
        return response.body;
      }
      return response.body;
    },
  });
  return { mutate, isLoading };
};

export default useBonusCodeMutation;
